import { 
  LOADER_STATUS, 
  SET_SELECTED_NOTES, 
  SET_SELECTED_ROW_NOTES, 
  SET_TABLE_DATA,
  SET_ENTITY_MASTER_LIST,
  SET_DEFAULT_ENTITY,
  SET_PROFILE_DATA,
  SET_SELECTED_GSTIN,
  SET_SELECTED_PERIODS,
  SET_OPEN_ADD_NOTES,
  SET_MODULE_IDS,
  SET_TOTAL_PAGES,
  SET_SELECTED_MODULE,
  SET_SELECTED_CATEGORY,
  SET_SEARCH,
  SET_COMMENT_TABLE_DATA,
  SET_FILES_DATA,
  SET_NOTES_HEADING_DATA
} from "./constants";

export const initialState = {
  loaderStatus: false,
  selectedNotes: [],
  selectedRowNotes: [],
  tableData: [],
  entityMasterList: [],
  defaultEntity: "",
  profileData: [],
  selectedGstin: [],
  selectedPeriods: [],
  openAddNotes: false,
  moduleIds: [],
  totalPages: 0,
  selectedModule: "",
  selectedCategory: "",
  search: "",
  commentTableData: [],
  filesData: [],
  notesHeadingData: null
};

/* eslint-disable default-case, no-param-reassign */
const notesReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
    case SET_SELECTED_NOTES:
      return {
        ...state,
        selectedNotes: action.selectedNotes,
      };
    case SET_SELECTED_ROW_NOTES:
      return {
        ...state,
        selectedRowNotes: action.selectedRowNotes,
      };
    case SET_TABLE_DATA:
      return {
        ...state,
        tableData: action.tableData,
      };
    case SET_ENTITY_MASTER_LIST:
      return {
        ...state,
        entityMasterList: action.entityMasterList,
      };
    case SET_DEFAULT_ENTITY:
      return {
        ...state,
        defaultEntity: action.defaultEntity,
      };
    case SET_PROFILE_DATA:
      return {
        ...state,
        profileData: action.profileData,
      };
    case SET_SELECTED_GSTIN:
      return {
        ...state,
        selectedGstin: action.selectedGstin,
      };
    case SET_SELECTED_PERIODS:
      return {
        ...state,
        selectedPeriods: action.selectedPeriods,
      };
    case SET_OPEN_ADD_NOTES:
      return {
        ...state,
        openAddNotes: action.openAddNotes,
      };
    case SET_MODULE_IDS:
      return {
        ...state,
        moduleIds: action.moduleIds,
      };
    case SET_TOTAL_PAGES:
      return {
        ...state,
        totalPages: action.totalPages,
      };
    case SET_SELECTED_MODULE:
      return {
        ...state,
        selectedModule: action.selectedModule,
      };
    case SET_SELECTED_CATEGORY:
      return {
        ...state,
        selectedCategory: action.selectedCategory,
      };
    case SET_SEARCH:
      return {
        ...state,
        search: action.search,
      };
    case SET_COMMENT_TABLE_DATA:
      return {
        ...state,
        commentTableData: action.commentTableData,
      };
    case SET_FILES_DATA:
      return {
        ...state,
        filesData: action.filesData,
      };
    case SET_NOTES_HEADING_DATA:
      return {
        ...state,
        notesHeadingData: action.notesHeadingData,
      };
    default:
      return state;
  }
};

export default notesReducer;
